import { writable } from 'svelte/store';

function colors_list() {
	const { subscribe, set, update } = writable(JSON.parse(localStorage.getItem('list_of_color')) || []);

	return {
		set,
		subscribe,
		updateColors: (newColor) =>
			update((list_of_color) => {
				if (Array.isArray(newColor)) {
					list_of_color.push(...newColor);
					list_of_color = [...new Set(list_of_color.map((x) => JSON.stringify(x)))].map(
						(y: any) => JSON.parse(y),
					);
					return list_of_color;
				}
				return [...list_of_color, newColor];
			}),
		reset: () => set([]),
	};
}

export const list_of_color = colors_list();
list_of_color.subscribe((val) => localStorage.setItem('list_of_color', JSON.stringify(val)));
